var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent141(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.156,
    height: 118,
    viewBox: "0 0 112.156 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#be8100;}.b,.c{fill:#fff;}.c{font-size:23px;font-family:ComicSansMS, Comic Sans MS;letter-spacing:-0.05em;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 112.156,
    height: 118,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.659
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -7, -7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.426,63.446a12.618,12.618,0,0,0,4.6-9.821c0-6.835-5.173-12.375-11.553-12.375H63.211A11.264,11.264,0,0,0,66.752,33c0-6.076-4.6-11-10.27-11h-.944a17.4,17.4,0,0,0,.944-5.5c0-9.113-6.9-16.5-15.4-16.5a14.5,14.5,0,0,0-2.425.261A14.307,14.307,0,0,1,41.078,8.25C41.078,15.843,35.33,22,28.241,22H25.674C20,22,15.4,26.924,15.4,33a11.264,11.264,0,0,0,3.541,8.25H16.688c-6.38,0-11.553,5.54-11.553,12.375a12.618,12.618,0,0,0,4.6,9.821A12.118,12.118,0,0,0,0,75.625C0,82.459,5.173,88,11.553,88H70.6c6.38,0,11.553-5.541,11.553-12.375A12.118,12.118,0,0,0,72.426,63.446Z",
    transform: "translate(7 7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.847,12.011V34a.918.918,0,0,0,.957.874h4.464A.918.918,0,0,0,13.225,34V12.011H16.9a1.733,1.733,0,0,0,1.353-2.983L11.389,2.762a2.044,2.044,0,0,0-2.706,0L1.822,9.028a1.733,1.733,0,0,0,1.353,2.983Z",
    transform: "translate(31.441 25.301)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(41.199 81.051)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.833,
    y: 0
  }, "TOP")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent141);
export default __webpack_public_path__ + "static/media/Component14-1.84c6e7c9d919c76460846b5c0eae2d24.svg";
export { ForwardRef as ReactComponent };